module.exports = __webpack_public_path__ + "media/src/images/web/sujet-experts-723b208da54c4c175f3309b55faab5e1.svg";